import _Runfest from './Runfest'

export const Runfest = _Runfest
export const ReduxFormRunfest = _Runfest
